<div class="row" [ngClass]="{ shrink: visibilitySizeStatus }">
    <div
        *ngFor="let shift of viewCollection"
        class="shift-container col-xs-12 {{
            'col-lg-' + 12 / viewCollection.length
        }}"
        [ngClass]="{ 'shift-active': shift.active }"
    >
        <app-shift-selector
            [shift]="shift"
            (shiftSelected)="shiftSelected($event)"
            [numerator]="numerator"
            [denominator]="denominator"
            [hasProduction]="hasProduction"
        ></app-shift-selector>
    </div>
</div>
